"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CMSCommonContainer = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _ContainerAllowedComponentsContainer = require("./ContainerAllowedComponentsContainer");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PLACEHOLDER_CLASS_NAMES = 'aem-Grid-newComponent';

/**
Below is the edit configuration defined for the carousel component
**/
/*const CMSCommonContainerEditConfig = {

    emptyLabel: 'Container',

      isEmpty: function(props : Props) {

               return true;

      }
};*/

/*interface Props {
  containerProps: any

}*/

/**
Below is the class deined for the carousel container and setting various container properties
**/
// exported class to use it in Next commerce
var CMSCommonContainer = /*#__PURE__*/function (_AllowedComponentsCon) {
  (0, _inherits2.default)(CMSCommonContainer, _AllowedComponentsCon);
  var _super = _createSuper(CMSCommonContainer);
  function CMSCommonContainer() {
    (0, _classCallCheck2.default)(this, CMSCommonContainer);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(CMSCommonContainer, [{
    key: "containerProps",
    get: function get() {
      var containerProps = (0, _get2.default)((0, _getPrototypeOf2.default)(CMSCommonContainer.prototype), "containerProps", this);
      var _ref = this,
        props = _ref.props;
      var bgcolor = props.userIsLoggedIn ? props.authenticatedUserBGColor : props.unauthenticatedUserBGColor ? props.unauthenticatedUserBGColor : null;
      var isFeatureCardsContainer = props.hasFeatureCard || false;
      containerProps.className = (containerProps.className || '') + ' section container' + (bgcolor && bgcolor.length ? ' bg-color-container' : '') + (isFeatureCardsContainer ? ' feature-cards-container' : '');
      var style = {
        backgroundColor: bgcolor
      };
      var desktopSpacing = props.desktopSpacing,
        mobileSpacing = props.mobileSpacing;
      containerProps['data-container-id'] = props.id;
      containerProps['data-container-bgcolor'] = props.backgroundColor;
      containerProps['data-container-padding'] = props.paddingLeftRight;
      containerProps['data-container-gridclassname'] = props.gridclassNames + (isFeatureCardsContainer ? ' feature-cards-container-grid' : '');
      containerProps['data-container-colclassname'] = props.columnClassNames;
      containerProps['data-container-cssclassname'] = props.cssClassName + (bgcolor && bgcolor.length ? 'container-spacing' : '');
      containerProps['data-container-containerdesktop-margin'] = desktopSpacing;
      containerProps['data-container-containermobile-margin'] = mobileSpacing;
      containerProps['style'] = bgcolor && bgcolor.length ? style : {};
      return containerProps;
    }
  }, {
    key: "placeholderProps",
    get: function get() {
      var props = (0, _get2.default)((0, _getPrototypeOf2.default)(CMSCommonContainer.prototype), "placeholderProps", this);
      props.placeholderClassNames = (props.placeholderClassNames || '') + ' ' + PLACEHOLDER_CLASS_NAMES;
      return props;
    }

    /**
     * Returns the properties to add on a specific child component
     *
     * @param   {Object} item     The item data
     * @param   {String} itemKey  The key of the item
     * @param   {String} itemPath The path of the item
     * @returns {Object} The map of properties to be added
     */
  }, {
    key: "getItemComponentProps",
    value: function getItemComponentProps(item, itemKey, itemPath) {
      var attrs = (0, _get2.default)((0, _getPrototypeOf2.default)(CMSCommonContainer.prototype), "getItemComponentProps", this).call(this, item, itemKey, itemPath);
      var _ref2 = this,
        props = _ref2.props;
      attrs.className = attrs.className || '';
      attrs.className += props.columnClassNames && props.columnClassNames[itemKey] ? ' ' + props.columnClassNames[itemKey] : '';
      return attrs;
    }
  }]);
  return CMSCommonContainer;
}(_ContainerAllowedComponentsContainer.AllowedComponentsContainer);
exports.CMSCommonContainer = CMSCommonContainer;
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/container')(CMSCommonContainer);
exports.default = _default;